import React from "react";
import OurProducts from "../OurProducts";  // ✅ import products page

const AudiovisualHire = () => {
  return <OurProducts />;   // ✅ render directly
};

export default AudiovisualHire;
